module.exports = __webpack_public_path__ + "img/logo0525.106c0f64.jpeg";